module.exports = require('../impls/not-loopable/not-loopable.js').notLoopable;